import axios from 'axios';

// Use empty string fallback for SWA emulator mode (relative paths go through SWA proxy)
const API_URL = process.env.REACT_APP_API_URL || '';

const apiClient = axios.create({
  baseURL: API_URL,
});

// Request interceptor to add demo token if present
apiClient.interceptors.request.use(
  (config) => {
    const demoToken = sessionStorage.getItem('demoToken');
    if (demoToken) {
      config.headers['Authorization'] = `Bearer ${demoToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Global response interceptor for automatic logout on 401 (session timeout/token expiry)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if demo session expired
      const demoSession = sessionStorage.getItem('demoSession');
      if (demoSession) {
        console.warn('Demo session expired (401). Redirecting to login...');
        sessionStorage.removeItem('demoToken');
        sessionStorage.removeItem('demoSession');
        window.location.href = '/';
      } else {
        console.warn('Session expired (401). Redirecting to login...');
        window.location.href = '/.auth/logout?post_logout_redirect_uri=/';
      }
      return new Promise(() => {}); // Never resolves - page is redirecting
    }
    return Promise.reject(error);
  }
);

export const getIdentity = async () => {
  // Attempt to read SWA principal for local dev to provide X-User-Email fallback
  let headers = {};
  let fallbackEmail = null;
  try {
    const resp = await fetch('/.auth/me');
    if (resp.ok) {
      const data = await resp.json();
      const principal = data?.clientPrincipal;
      const email = principal?.userDetails;
      if (email) {
        headers['X-User-Email'] = email;
        fallbackEmail = email;
      }
    }
  } catch (e) {
    // ignore; backend may still resolve via principal if available
  }
  const response = await apiClient.get('/api/auth/whoami', { headers });
  const whoami = response.data || {};
  // Ensure we always return an email when principal provides it
  return {
    user_id: whoami.user_id,
    email: whoami.email || fallbackEmail || null,
    provider: whoami.provider || null,
  };
};

export default { getIdentity };
